export default {
	keys: {
		state: "bothive_state",
		uniqueIdentifier: "bothive_id",
		trackingId: "BHC-id",
		sessionUuid: "cb_su",
		concent: "concent",
	},
};
